/* Mo Chara — Merch grid: filter, sort, reveal. No external deps. */
(function () {
  var root = document.querySelector('[data-mc-merch]');
  if (!root) return;

  var grid = root.querySelector('.mc-merch-grid');
  var chips = Array.prototype.slice.call(root.querySelectorAll('.mc-merch-chip'));
  var sortSel = root.querySelector('[data-mc-sort]');
  var countNum = root.querySelector('[data-mc-count-num]');
  var noResults = root.querySelector('[data-mc-noresults]');
  if (!grid) return;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('.mc-merch-card'));
  if (!cards.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var currentFilter = 'all';

  /* sold-out products always sink below in-stock ones */
  function soldOut(c) { return c.dataset.available === 'false' ? 1 : 0; }

  /* ---- FLIP: animate position changes; fade entering items ---- */
  function flip(mutate) {
    if (reduce || !grid.animate) { mutate(); return; }
    var visibleBefore = cards.filter(function (c) { return !c.classList.contains('is-hidden'); });
    var first = new Map();
    visibleBefore.forEach(function (c) { first.set(c, c.getBoundingClientRect()); });

    mutate();

    cards.forEach(function (c) {
      if (c.classList.contains('is-hidden')) return;
      var f = first.get(c);
      var l = c.getBoundingClientRect();
      if (f) {
        var dx = f.left - l.left;
        var dy = f.top - l.top;
        if (dx || dy) {
          c.animate(
            [{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'translate(0,0)' }],
            { duration: 420, easing: 'cubic-bezier(0.22,0.61,0.36,1)' }
          );
        }
      } else {
        c.animate(
          [{ opacity: 0, transform: 'scale(0.96)' }, { opacity: 1, transform: 'scale(1)' }],
          { duration: 280, easing: 'ease-out' }
        );
      }
    });
  }

  function updateCount() {
    if (!countNum) return;
    var n = cards.filter(function (c) { return !c.classList.contains('is-hidden'); }).length;
    countNum.textContent = n;
    if (noResults) noResults.hidden = n !== 0;
  }

  function applyFilter(val) {
    currentFilter = val;
    chips.forEach(function (b) {
      var on = b.dataset.filter === val;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    flip(function () {
      cards.forEach(function (c) {
        c.classList.toggle('is-hidden', val !== 'all' && c.dataset.type !== val);
      });
    });
    updateCount();
  }

  function applySort(mode) {
    var sorted = cards.slice().sort(function (a, b) {
      var s = soldOut(a) - soldOut(b);
      if (s) return s;
      switch (mode) {
        case 'price-asc':  return (+a.dataset.price) - (+b.dataset.price);
        case 'price-desc': return (+b.dataset.price) - (+a.dataset.price);
        case 'az':         return a.dataset.title.localeCompare(b.dataset.title);
        default:           return (+a.dataset.order) - (+b.dataset.order);
      }
    });
    flip(function () {
      sorted.forEach(function (c) { grid.appendChild(c); });
    });
  }

  chips.forEach(function (btn) {
    btn.addEventListener('click', function () {
      applyFilter(btn.dataset.filter);
      /* keep the URL shareable without triggering a scroll jump */
      if (window.history && history.replaceState) {
        var h = btn.dataset.filter === 'all' ? location.pathname + location.search : '#' + btn.dataset.filter;
        history.replaceState(null, '', h);
      }
    });
  });
  if (sortSel) sortSel.addEventListener('change', function () { applySort(sortSel.value); });

  /* ---- initial order: in-stock first, sold-out after (respects data-order) ---- */
  (function initialOrder() {
    var sorted = cards.slice().sort(function (a, b) {
      var s = soldOut(a) - soldOut(b);
      if (s) return s;
      return (+a.dataset.order) - (+b.dataset.order);
    });
    sorted.forEach(function (c) { grid.appendChild(c); });
  })();

  /* ---- deep-link a filter via URL hash (e.g. /collections/merch#clothing) ---- */
  function filterFromHash() {
    var h = (location.hash || '').replace(/^#/, '').toLowerCase();
    if (!h) { return; }
    var match = chips.filter(function (b) { return b.dataset.filter === h; })[0];
    if (match) { applyFilter(match.dataset.filter); }
  }
  filterFromHash();
  window.addEventListener('hashchange', filterFromHash);

  /* ---- staggered scroll reveal ---- */
  if (!reduce && 'IntersectionObserver' in window) {
    grid.classList.add('mc-merch-reveal');
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var card = entry.target;
        var idx = cards.indexOf(card);
        card.style.transitionDelay = Math.min(idx, 7) * 45 + 'ms';
        card.classList.add('is-in');
        obs.unobserve(card);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    cards.forEach(function (c) { io.observe(c); });
  }
})();
